import { useGetIsUngated } from './useGetIsUngated';
import { GATES } from '../constants/auth';
export const useHasChangesRequested = () => {
  const getIsUngated = useGetIsUngated();
  return getIsUngated(GATES.CHANGES_REQUESTED) || getIsUngated(GATES.AGENT_APPROVER);
};